import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isEventTarget as n, on as t } from "./events.js";
import { equals as r } from "./lang.js";
import { createDeferred as e, onAbort as o, createAbortError as u } from "./promiseUtils.js";
var c = /\?(\.|$)/g;

function i(n, t, r, e) {
  var o = Array.isArray(t) ? t : t.indexOf(",") > -1 ? t.split(",") : [t],
      u = f(n, t, r, e);

  var _iterator = _createForOfIteratorHelper(o),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _i = _step.value;

      var _t = _i.trim().replace(c, "$1"),
          _e = n.get(_t);

      r.call(n, _e, _e, _t, n);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return u;
}

function f(n, t, r, e) {
  return n.watch(t, r, e);
}

function l(n, t, r, e) {
  return N(n, t, null, r, e);
}

function s(n, t, r, e) {
  return z(n, t, U, r, e);
}

function a(n, t, r, e) {
  return N(n, t, U, r, e);
}

function m(n, t, r, e) {
  return z(n, t, V, r, e);
}

function p(n, t, r, e) {
  return N(n, t, V, r, e);
}

function v(n, t, r, e) {
  return z(n, t, k, r, e);
}

function d(n, t, r, e) {
  return N(n, t, k, r, e);
}

function h(n, t, r, e) {
  return z(n, t, q, r, e);
}

function g(n, t, r, e) {
  return N(n, t, q, r, e);
}

function y(n, t, r, e) {
  return z(n, t, B, r, e);
}

function j(n, t, r, e) {
  return N(n, t, B, r, e);
}

function b(n, t, r, e) {
  return z(n, t, C, r, e);
}

function A(n, t, r, e) {
  return N(n, t, C, r, e);
}

function w(n, t, e, o, u) {
  return z(n, t, function (n) {
    return r(e, n);
  }, o, u);
}

function x(n, t, e, o, u) {
  return N(n, t, function (n) {
    return r(e, n);
  }, o, u);
}

function O(n, t, r, e) {
  var o = !1;
  var u = n.watch(t, function (t, e, u, c) {
    o || r.call(n, t, e, u, c);
  }, e);
  return {
    remove: function remove() {
      u.remove();
    },
    pause: function pause() {
      o = !0;
    },
    resume: function resume() {
      o = !1;
    }
  };
}

function $(r, e, o, u, c, f, l) {
  var s = {};

  function a(n) {
    var t = s[n];
    t && (f && f(t.target, n, r, o), t.handle.remove(), delete s[n]);
  }

  var m = i(r, e, function (e, i, f) {
    a(f), n(e) && (s[f] = {
      handle: t(e, o, u),
      target: e
    }, c && c(e, f, r, o));
  }, l);
  return {
    remove: function remove() {
      m.remove();

      for (var _n in s) {
        a(_n);
      }
    }
  };
}

function z(n, t, r, e, o) {
  var u = n.watch(t, function (t, o, u, c) {
    r && !r(t) || null == e || e.call(n, t, o, u, c);
  }, o);

  if (Array.isArray(t)) {
    var _iterator2 = _createForOfIteratorHelper(t),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _c = _step2.value;

        var _o = n.get(_c);

        r && r(_o) && (null == e || e.call(n, _o, _o, t, n));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  } else {
    var _o2 = n.get(t);

    r && r(_o2) && (null == e || e.call(n, _o2, _o2, t, n));
  }

  return u;
}

function N(n, t, r, c, i) {
  var f = "function" == typeof c ? c : null,
      l = "object" == typeof c ? c : null;
  "boolean" == typeof c && (i = c);
  var s,
      a = !1;

  function m() {
    s && (s.remove(), s = null);
  }

  var p = e();
  o(l, function () {
    m(), p.reject(u());
  });
  var v = {
    then: p.promise.then.bind(p.promise),
    catch: p.promise.catch.bind(p.promise),
    remove: m
  };
  return Object.freeze(v), s = z(n, t, r, function (t, r, e, o) {
    a = !0, m(), f && f.call(n, t, r, e, o), p.resolve({
      value: t,
      oldValue: r,
      propertyName: e,
      target: o
    });
  }, i), a && m(), v;
}

function U(n) {
  return !!n;
}

function V(n) {
  return !n;
}

function k(n) {
  return !0 === n;
}

function q(n) {
  return !1 === n;
}

function B(n) {
  return void 0 !== n;
}

function C(n) {
  return void 0 === n;
}

export { i as init, $ as on, l as once, O as pausable, f as watch, s as when, y as whenDefined, j as whenDefinedOnce, w as whenEqual, x as whenEqualOnce, h as whenFalse, g as whenFalseOnce, m as whenNot, p as whenNotOnce, a as whenOnce, v as whenTrue, d as whenTrueOnce, b as whenUndefined, A as whenUndefinedOnce, N as whenValidOnce };